import styled from "styled-components";

import { CombinedIcon } from "@similarweb/pro-logic-components";

export const StyledCombinedIcon = styled(CombinedIcon)`
    flex-shrink: 0;
    width: 24px;
    height: 24px;
`;
